import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { email, helpers, minLength, required } from "@vuelidate/validators";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import Cleave from "vue-cleave-component";
  import { validPhoneNumber } from "@/helpers/validation";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import ErrorMessages from "@/constants/errorsMessages";
  import SubmitMessages from "@/constants/submitMessages";
  import LottrackrPoweredIcon from "@/components/ui/LottrackrPoweredIcon.vue";
  import store from "@/store";
  import router from "@/router";
  import { POSITION, useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AskAQuestionView',
  setup(__props, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(900);
  const toast = useToast();
  const isSubmitting = ref(false);
  const success = ref(false);

  const formFields = {
    projectTitle: "",
    message: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  };

  const form = reactive(Object.assign({}, formFields));

  const rules = computed(() => ({
    projectTitle: { required },
    message: { required, minLength: minLength(10) },
    firstName: { required },
    lastName: { required },
    email: { required, email },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
  }));

  const v$ = useVuelidate(rules, form);

  const onSubmit = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect || isSubmitting.value) return;

    isSubmitting.value = true;
    store
      .dispatch("user/askAQuestionEmail", form)
      .then(() => {
        success.value = true;
      })
      .catch(() => {
        toast.error(ErrorMessages.ERROR_SOMETHING_WENT_WRONG, {
          position: POSITION.TOP_LEFT,
        });
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  };

  const closePage = () => {
    router.push("/");
  };

const __returned__ = { isDesktop, toast, isSubmitting, success, formFields, form, rules, v$, onSubmit, closePage, computed, reactive, ref, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get minLength() { return minLength }, get required() { return required }, get phoneNumberOption() { return phoneNumberOption }, get Cleave() { return Cleave }, get validPhoneNumber() { return validPhoneNumber }, get useIsDesktop() { return useIsDesktop }, get ErrorMessages() { return ErrorMessages }, get SubmitMessages() { return SubmitMessages }, LottrackrPoweredIcon, get store() { return store }, get router() { return router }, get POSITION() { return POSITION }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})